import React from 'react'
import { FaLinkedin, FaGithub, FaInstagram } from "react-icons/fa"

export const links = [
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/in/pedro-cerna/",
    icon: <FaLinkedin/>,
  },
]
